import * as z from 'zod/mini';
import { createQueryParamState } from './manager';

const schemaForParse = z.pipe(
    z.array(
        z.pipe(
            z.tuple([z.string(), z.array(z.string())]),
            z.transform((entry) => [entry[0], Array.from(new Set(entry[1])).sort((a, b) => a.localeCompare(b))]),
        ),
    ),
    z.transform((entries) => Object.fromEntries(entries) as Record<string, string[]>),
);

const baseState = createQueryParamState(
    'hiddenSubjects',
    (queryParamValue) => {
        try {
            return schemaForParse.parse(JSON.parse(queryParamValue));
        } catch (_) {
            return {};
        }
    },
    (subjectsToTypes) => {
        const entries = Object.entries(subjectsToTypes);
        if (entries.length === 0) {
            return '';
        }

        return JSON.stringify(
            entries.map((entry) => [entry[0], Array.from(new Set(entry[1])).sort((a, b) => a.localeCompare(b))]),
        );
    },
);

export const hiddenSubjectsGlobalState = {
    ...baseState,
    createAddUpdate: (subject: string, itemType: string) => {
        const newStateValue = structuredClone(baseState.get());

        newStateValue[subject] = newStateValue[subject] ?? [];
        newStateValue[subject].push(itemType);

        return baseState.createUpdate(newStateValue);
    },
    createRemoveUpdate: (subject: string, itemType: string) => {
        const newStateValue = structuredClone(baseState.get());

        if (newStateValue[subject]) {
            newStateValue[subject] = newStateValue[subject].filter((t) => t !== itemType);
            if (newStateValue[subject].length === 0) {
                delete newStateValue[subject];
            }
        }

        return baseState.createUpdate(newStateValue);
    },
};
